import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

/**
 * 12-question intake preview — editorial snapshot of the diagnostic.
 * Links into /apply (Contact form) rather than duplicating it here.
 */
const questions = [
  ["01", "Brand name and website"],
  ["02", "Primary product category"],
  ["03", "Hero SKUs at launch"],
  ["04", "Retail price range"],
  ["05", "Annual brand revenue"],
  ["06", "Current Amazon presence"],
  ["07", "EU trademark protection"],
  ["08", "EU labelling readiness"],
  ["09", "Monthly PPC budget"],
  ["10", "Target Amazon EU go-live"],
  ["11", "Priority EU market"],
  ["12", "What makes your brand different"],
];

export default function BearingIntake() {
  return (
    <section className="border-b border-line" data-testid="bearing-intake">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16 sm:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <p className="label-mono">/ The intake</p>
            <h2 className="mt-8 sm:mt-10 font-serif-i text-[36px] sm:text-[44px] lg:text-[56px] text-ink leading-[1.05] tracking-tight">
              Twelve questions. <span className="text-coral">Four minutes.</span>
            </h2>
            <p className="mt-8 text-ink-soft leading-[1.7] text-[16px] sm:text-lg max-w-md">
              The intake is short on purpose. Twelve curated questions are enough to assemble a
              precise Bearing — anything beyond that is research Traeva does on your behalf.
            </p>
            <p className="mt-8 font-mono text-[10px] sm:text-[11px] tracking-[0.22em] uppercase text-ink-muted">
              Confidential · Used only to prepare your Bearing · Never shared
            </p>

            <div className="mt-12">
              <Link
                to="/apply"
                data-testid="intake-cta"
                className="btn-primary"
              >
                Begin the intake <ArrowRight size={16} strokeWidth={1.6} />
              </Link>
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <ul className="border-t border-line">
              {questions.map(([n, t], i) => (
                <Reveal key={n} delay={i * 0.03}>
                  <li
                    data-testid={`intake-q-${n}`}
                    className="grid grid-cols-12 items-baseline gap-4 py-5 border-b border-line"
                  >
                    <span className="col-span-2 sm:col-span-1 font-mono text-[11px] tracking-[0.2em] uppercase text-coral">
                      {n}
                    </span>
                    <span className="col-span-10 sm:col-span-11 text-[16px] sm:text-[18px] text-ink leading-snug">
                      {t}
                    </span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
